import React from "react";
import {
  Box,
  Container,
  makeStyles,
} from "@material-ui/core";

import Page from "src/components/Page";
import View from "./View";
import PageHeader from "../../components/PageHeader";

import ViewListIcon from "@material-ui/icons/ViewList";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#f7f7fa",
    minHeight: "100%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(4),
  },

  content: {
    marginTop: theme.spacing(3),
  },
}));

const EventView = () => {
  const classes = useStyles();

  return (
    <Page
      className={classes.root}
      title="Exhibition List"
    >
      <Container maxWidth="lg">
        <PageHeader
          icon={<ViewListIcon />}
          title="Exhibition List"
          subtitle="View and manage exhibition listings"
          showSession
        />

        <Box className={classes.content}>
          <View />
        </Box>
      </Container>
    </Page>
  );
};

export default EventView;